/**
 * Hits requested per bucket from `POST /v1/search` when the response is grouped
 * (the server's own cap). The client caps what it renders separately, see
 * `SEARCH_V2_GROUP_PAGING`.
 *
 * @example
 * searchServiceAPI.search({ query, groupBy: 'workspace', limit: SEARCH_V2_FETCH_LIMIT });
 */
export const SEARCH_V2_FETCH_LIMIT = 100;

/**
 * How many exact hits a search-v2 group shows: `INITIAL` on arrival, then `STEP`
 * more per "Show more" press. Both are guesses to tune from the `[Search] Show more
 * results` event; change them here only.
 *
 * @example
 * const { visibleCount } = useRevealedCount({ total: results.length, resetKey: results });
 */
export const SEARCH_V2_GROUP_PAGING = { INITIAL: 5, STEP: 10 } as const;

/**
 * How many hits a resource picker (`SelectContent`, `ResourceSelector`, the events
 * `AddResourceSheet`) shows: `INITIAL` per search, then `STEP` more per "Show more"
 * press. A picker is a scrolled sheet or dialog, so it starts wider than a search
 * page group (`SEARCH_V2_GROUP_PAGING`). Change them here only.
 *
 * @example
 * const { INITIAL: initial, STEP: step } = SEARCH_V2_PICKER_PAGING;
 * const { visibleCount } = useRevealedCount({ total: hits.length, resetKey: data, initial, step });
 */
export const SEARCH_V2_PICKER_PAGING = { INITIAL: 10, STEP: 10 } as const;
